/*
angelCake v3.0 (http://angelcake.executiveresults.ca)
Copyright 2018 Executive Results
Licensed under the MIT license
*/







    Vue.config.ignoredElements.push('ac-formgroup');
    Vue.config.ignoredElements.push('ac-panel');
    Vue.config.ignoredElements.push('ac-fieldset');
    Vue.config.ignoredElements.push('ac-loader');
    Vue.config.ignoredElements.push('ac-toolbar');
    Vue.config.ignoredElements.push('ac-toolbar-left');
    Vue.config.ignoredElements.push('ac-toolbar-right');
    Vue.config.ignoredElements.push('ac-toolbar-centre');
    Vue.config.ignoredElements.push('sd-button-group-vertical-dark');
    var vueTemplate = '';
angelCake.generateCardTable = function(domTarget,ajaxSource,inlineData,cssClasses){

  return new Vue({
    el: domTarget,
    templateX : '#sd-table-template',
    template : `
<ac-panel class=" pad-none-all scroll-horizontally scroll-vertically" v-bind:id="panelID" style="-webkit-overflow-scrolling: touch;" v-bind:class="cssClasses">
 <ac-toolbar class="sticky-top bg-white border-sm-white-darker-bottom" style="flex-wrap:nowrap;">
   
    <ac-toolbar-left>
     
    <div class="pad-top pad-bottom pad-xs-left pad-xs-right" v-if="myData.table_options.table_title!='' || myData.table_options.table_subtitle!=''">
      <h5 class="text-black-light text-bold mar-none" v-if="myData.table_options.table_title!=''">{{myData.table_options.table_title}}</h5>
      <h6 class="mar-xs-top text-black-lightest" v-if="myData.table_options.table_subtitle!=''">{{myData.table_options.table_subtitle}}</h6>
    </div>
  </ac-toolbar-left>
    <ac-toolbar-centre>
    </ac-toolbar-centre>
    <ac-toolbar-right>
      <div  class="toolbar-buttons">
      <button type="button" class="button-transparent" v-on:click="setCardView(true)" v-bind:class="{'active':cardView==true}" v-if="myData.table_options.has_card_view && view_button_count>1">
        <i class="icon-profile"></i>
      </button>
      <button type="button" class="button-transparent" v-on:click="setGridView(true)" v-bind:class="{'active':gridView==true}" v-if="myData.table_options.has_grid_view && view_button_count>1">
        <i class="icon-grid"></i>
      </button>
      <button type="button" class="button-transparent" v-on:click="setChartView(true)" v-bind:class="{'active':chartView==true}" v-if="myData.table_options.has_chart_view && view_button_count>1">
        <i class="icon-pie-chart"></i>
      </button>
      <button type="button" class="button-transparent" v-on:click="setTableView(true)" v-bind:class="{'active':tableView==true}" v-if="myData.table_options.has_table_view && view_button_count>1">
        <i class="icon-list"></i>
      </button>
      </div>
      <ac-formgroup class="pad-none-right pad-none-top pad-none-bottom mar-none-all" v-if="myData.table_options.enable_search">
        <input type="text" class="small" :placeholder="myData.table_options.labels.placeholder_search" v-model="search_string" />
      </ac-formgroup>
      <div class="" v-if="myData.filters.length>0">
        <button type="button" class="button-transparent" v-on:click="showAside();">        
          <i class="icon-filter"></i>
        </button>
      </div>
    </ac-toolbar-right>
  </ac-toolbar>
  <table v-bind:class="{'grid-view': gridView==true, 'card-view' : cardView==true}" style="border-width:0px !important;">
    <thead v-if="!is_loading && (tableView || gridView || cardView)">
      <tr>
          <th 
            v-for="th in myData.table_header" 
            v-bind:class="'sort-'+th.sort_direction" 
            v-on:click="sortList(th.sort_key,th.sort_direction);">
            <span>{{th.column_label}}</span>
          </th>
      </tr>
    </thead>
    <tbody v-bind:class="{'invisible':is_loading}" v-if="myData.table_body.length!=0 && (cardView)">
      <tr v-for="tr in myData.table_body" v-on:click="goto(tr.tr_url_destination,tr.td_icon)"  v-bind:class="{'clickable-row':tr.tr_url_destination!=''}">

      <img v-bind:src="tr.td_icon" v-if="tr.td_icon " style="width:100%;height:300px;object-fit:cover; margin-bottom:20px;" />
      <div v-if="!tr.td_icon " style="width:100%;height:300px; margin-bottom:20px;" class="bg-white-darker">&nbsp;</div>
      <div class="grid-auto-150" style="grid-gap:10px;">
        <td v-for="(td,index) in tr.td" v-bind:class="{ 'document-icon-text': myData.table_options.icon_column_index == index}">
        	
         		<h6 class="text-bold mar-none text-grey">{{myData.table_header[index].column_label}}</h6>
            <p class="mar-none-top mar-sm-bottom">{{td}}</p>
        
        </td>
        </div>
      </tr>
    </tbody>
    <tbody v-bind:class="{'invisible':is_loading}" v-if="myData.table_body.length!=0 && (tableView || gridView) && !cardView">
      <tr v-for="tr in myData.table_body" v-on:click="goto(tr.tr_url_destination,tr.td_icon)"  v-bind:class="{'clickable-row':tr.tr_url_destination!=''}">
        <td v-for="(td,index) in tr.td" v-bind:class="{ 'document-icon-text': myData.table_options.icon_column_index == index}">
          <span>
            <img v-bind:src="tr.td_icon" v-if="myData.table_options.icon_column_index == index && tr.td_icon " />
            <img src="/angelCake/dist/svg_icons/file_icons/file.svg" v-if="myData.table_options.icon_column_index == index && !tr.td_icon && myData.table_options.has_grid_view" />
            <span>
            {{td}}
            </span>
          </span>
        </td>
      </tr>
    </tbody>
    <tbody v-if="myData.table_body.length==0 && !is_loading">
      <tr>
        <td v-bind:colspan="myData.table_header.length" style="display:flex;">
          <span>{{myData.table_options.labels.empty_table}}</span>
        </td>
      </tr> 
    </tbody>
  </table>
  <div class="col-1-1 pad-top pad-sm-right pad-sm-bottom" v-bind:class="{'hide':!chartView}">
    <div v-bind:id="panelID+'_chart'" v-bind:style="{'height':myData.table_options.chart_height, 'width': '100%'}"></div>
    
  </div>

  
  <ac-toolbar class="sticky-bottom bg-white border-sm-white-darkest-top" v-if="myData.table_options.footer_text!='' || myData.table_options.enable_pagination" style="flex-wrap:nowrap;">
    <ac-toolbar-left>
      <button 
        type="button" 
        class="button-transparent hide-below-lg" 
        v-on:click="prevPage();"
        v-if="myData.table_options.enable_pagination && myData.table_options.total_page_count>1 && myData.table_body.length>0"
        :disabled="myData.table_options.current_page_number==1">
        <i class="icon-chevron-left"></i>
      </button>
      <button 
        type="button" 
        class="button-transparent hide-below-lg" 
        v-on:click="nextPage()"
        v-if="myData.table_options.enable_pagination && myData.table_options.total_page_count>1 && myData.table_body.length>0"
        :disabled="myData.table_options.current_page_number==myData.table_options.total_page_count">
        <i class="icon-chevron-right"></i>
      </button>
      <ac-formgroup class="pad-none-all mar-none-bottom mar-sm-left hide-below-lg" v-if="myData.table_options.enable_pagination && myData.table_options.total_page_count>1 && myData.table_body.length>0">
        <input type="number" class="small" v-model="custom_page_number" v-bind:max="myData.table_options.total_page_count" min="1" :placeholder="myData.table_options.labels.placeholder_page_number" style="width:70px;" />
      </ac-formgroup>
      <button 
        type="button" 
         v-if="myData.table_options.enable_pagination && myData.table_options.total_page_count>1 && myData.table_body.length>0"
        v-on:click="changePage();" 
        :disabled="custom_page_number==''"
        class="button-transparent hide-below-lg">
        <span>{{myData.table_options.labels.button_go_to_page}}</span>
      </button>

    </ac-toolbar-left>
    <ac-toolbar-centre></ac-toolbar-centre>
    <ac-toolbar-right class="pad-xs-bottom pad-xs-top">
      <h6 class="pad-xs-top pad-xs-bottom hide-below-lg">{{myData.table_options.footer_text}}</h6>
      <button 
        type="button" 
        class="button-transparent hide-above-md" 
        v-on:click="prevPage();"
        v-if="myData.table_options.enable_pagination && myData.table_options.total_page_count>1 && myData.table_body.length>0"
        :disabled="myData.table_options.current_page_number==1">
        <i class="icon-chevron-left"></i>
      </button>
      <button 
        type="button" 
        class="button-transparent hide-above-md" 
        v-on:click="nextPage()"
        v-if="myData.table_options.enable_pagination && myData.table_options.total_page_count>1 && myData.table_body.length>0"
        :disabled="myData.table_options.current_page_number==myData.table_options.total_page_count">
        <i class="icon-chevron-right"></i>
      </button>
      <ac-formgroup class="pad-none-all mar-none-bottom mar-sm-left hide-above-md" v-if="myData.table_options.enable_pagination && myData.table_options.total_page_count>1 && myData.table_body.length>0">
        <input type="number" class="small" v-model="custom_page_number" v-bind:max="myData.table_options.total_page_count" min="1" :placeholder="myData.table_options.labels.placeholder_page_number" style="width:70px;" />
      </ac-formgroup>
      <button 
        type="button" 
         v-if="myData.table_options.enable_pagination && myData.table_options.total_page_count>1 && myData.table_body.length>0"
        v-on:click="changePage();" 
        :disabled="custom_page_number==''"
        class="button-transparent hide-above-md">
        <span>{{myData.table_options.labels.button_go_to_page}}</span>
      </button>
    </ac-toolbar-right>
  </ac-toolbar>
  <!--preloader animation-->
  <div 
    style="position:absolute;left:0;top:0;width:100%;height:100%;background-color:rgba(255,255,255,0.8);display:table;" 
    v-if="is_loading">
    <div style="text-align:center;vertical-align: middle;display:table-cell;">
      <h3 class="text-loader text-bold pad-xs-bottom text-blue-darkest" data-text="Loading...">Loading...</h3>
    </div>
  </div>
  <!-- end preloader animation -->
  <!--mask when aside is open-->
  <div 
    style="position:absolute;left:0;top:0;width:100%;height:100%;background-color:rgba(255,255,255,0.8);cursor:pointer;z-index:4;" 
    v-on:click="hideAside();resetFilters();"
    v-bind:class="{'hide': showFilters!=true}"></div>
  <!-- end mask when aside is open -->
  <aside v-bind:class="{'shown': showFilters==true}" v-if="myData.filters.length>0" style="height:100%;max-height:100%;">
    <ac-toolbar class="sticky-top">
      <ac-toolbar-left>
        <h5 class="text-bold" style="padding-left:10px;">{{myData.table_options.labels.advanced_search_title}}</h5>
      </ac-toolbar-left>
      <ac-toolbar-centre></ac-toolbar-centre>
      <ac-toolbar-right>
        <button class="button-transparent" v-on:click="hideAside()">
          <i class="icon-logout"></i>
        </button>
      </ac-toolbar-right>
    </ac-toolbar>
    <!-- <div style="min-height:calc(100% - 100px);"> -->
    <div style="margin-left:10px;margin-right:13px;margin-top:-15px;">
    <form accept-charset="utf-8" action="" method="post" v-bind:id="'form_'+panelID">

      <ac-fieldset 
      v-for="filter in myData.filters" 
      :key="filter.keyname" 
      style="position:relative;" 
      v-if="filter.shown && filter.type!='hidden'" 
      v-bind:style="[filter.domOrder ? {'order':filter.domOrder} : {}]"
      >
  
        <!-- start date -->
        <div v-if="filter.type=='date'" class="row">
          <ac-formgroup class="col-1-1 mar-none-bottom" v-bind:class="{'col-1-1':filter.optionvalue=='range','col-1-2':filter.optionvalue!=='range'}">
            <label>{{filter.label}}</label>
            <select2 
              :options="filter.options" 
              v-model="filter.optionvalue" 
              :required="filter.shown"
              :placeholder="myData.table_options.labels.placeholder_select"></select2>
          </ac-formgroup>
          <ac-formgroup v-bind:class="{'hide':filter.optionvalue=='range'}" class="pad-sm-left pad-sm-right col-1-2 mar-none-bottom">
            <label>&nbsp;</label>
            <datepicker v-model="filter.date" :data-required="filter.optionvalue!='range'"></datepicker>
          </ac-formgroup>
          <ac-formgroup v-bind:class="{'hide':filter.optionvalue!='range'}" class="pad-sm-left pad-xs-right col-1-2 mar-none-bottom">
            <label>From</label>
            <datepicker v-model="filter.date_from" :data-required="filter.optionvalue=='range'"></datepicker>
          </ac-formgroup>
          <ac-formgroup v-bind:class="{'hide':filter.optionvalue!='range'}" class="pad-xs-left pad-sm-right col-1-2 mar-none-bottom">
            <label>To</label>
            <datepicker v-model="filter.date_to" :data-required="filter.optionvalue=='range'"></datepicker>
          </ac-formgroup>
        </div>
        <!-- end date -->
        <!-- start string -->
        <div v-if="filter.type=='string'" class="row">
          <ac-formgroup class="col-1-2 pad-xs-right mar-none-bottom">
            <label>{{filter.label}}</label>
            <select2 
              :options="filter.options" 
              v-model="filter.optionvalue" 
              :required="filter.shown"
              :placeholder="myData.table_options.labels.placeholder_select"></select2>
          </ac-formgroup>
          <ac-formgroup class="col-1-2 pad-xs-left mar-none-bottom">
            <label>&nbsp;</label>
            <input type="text" v-model="filter.value" :required="filter.shown" />
          </ac-formgroup>
        </div>
        <!-- end string -->
        <!-- start select -->
        <div v-if="filter.type=='select'" class="row">
          <ac-formgroup class="col-1-1 pad-sm-left pad-sm-right mar-none-bottom">
            <label>{{filter.label}}</label>
            <select2 
              :options="filter.options" 
              v-model="filter.optionvalue" 
              :required="filter.shown"
              :placeholder="myData.table_options.labels.placeholder_select"></select2>
          </ac-formgroup>
        </div>
        <!-- end select -->
        <i 
          class="icon-circle-x text-grey" 
          style="position:absolute;top:8px;right:12px;" 
          v-if="myData.filters.length>=min_filter_count"
          v-on:click="filter=removeFilter(filter);"></i>
        </ac-fieldset>
        
        <button type="submit"  v-bind:id="'submitbutton_'+panelID" style="display:none;">hidden submit button for filter validation purposes</button>
        
      </div>
    </form>
    </div>
    <ac-toolbar class="sticky-bottom">
      <ac-toolbar-left>
      
        <ac-dropdown class="mar-none-left mar-xs-right button-white" v-if="myData.filters.length>=min_filter_count">
          <i class="icon-circle-plus"></i>
          <span>{{myData.table_options.labels.button_filters_dropdown}}</span>
          
          <ac-dropdown-content>
              <sd-button-group-vertical-dark>
                <a 
                  href="javascript:void(0);"  
                  v-for="filter in myData.filters" 
                  v-on:click="filter=addFilter(filter);" 
                  v-if="!filter.shown && filter.type!='hidden'">
                  <span>{{filter.label}}</span>
                </a>
              </sd-button-group-vertical-dark>
            </ac-dropdown-content>
          </ac-dropdown>
          <button type="button" class="button-submit-small" v-on:click="validateFilters();">
            <span>{{myData.table_options.labels.button_submit_filters}}</span>
          </button>
          
      </ac-toolbar-left>
      <ac-toolbar-centre class="mar-none-all pad-none-all" style="width:1px;">
      </ac-toolbar-centre>
      <ac-toolbar-right>
        <button type="button" class="button-transparent" v-on:click="clearFilters();" v-if="selectedFilterCount>0 && !myData.table_options.has_chart_view">
          <span>{{myData.table_options.labels.button_clear_filters}}</span>
        </button>
      </ac-toolbar-right>
    </ac-toolbar>
  </aside>

</ac-panel>
    `,
    data : {
    	cssClasses : cssClasses,
      myData : {
      	
        table_options:{
          table_title : '',
          table_subtitle : '',
          advanced_search_title : '',
          enable_pagination : false,
          total_page_count: 1,
          current_page_number: 1,
          icon_column_index : 1,
          livesearch_throttle_speed : 200,
          enable_search : false,
          has_grid_view : false,
          has_chart_view : false,
          has_table_view : true,
          has_card_view : false,
          chart_height : 600,
          chart_type : 'vertical-bar',
          footer_text : ''
        },
        table_body:[],
        table_header: [],
        filters : []
      },
      min_filter_count : 0,
      view_button_count : 0,
      //chart_height : '300px',
      showFilters : false,
      selector_options : [],
      is_loading : true,
      unSelectedFilterCount : 0,
      selectedFilterCount : 0,
      orderCounter : 0,
      myChart : null,
      custom_page_number : '',
      ajaxLoadCount : 0,
      sort_key : '',
      sort_direction : '',
      search_string : '',
      searchbox_used : false,
      panelID : (function(){
        var d = new Date();
        return d.getTime();
      })(),
      gridView : false,
      chartView : false,
      tableView : true,
      cardView : false,
      panelWidth : 3000,
      debouncedSearch : angelCake.debounce(function(val){
          this.searchbox_used=true;
          this.myData.table_options.current_page_number=1;
          this.submitFilters();
      },800)
    },
    methods:{
      goto :function (loc,imgURL){
        if(angelCake.isCKEditorImageBrowser){
          window.opener.CKEDITOR.tools.callFunction(window.ckFunctionNum, imgURL);
          window.close();
        }else{
          if(loc!=''){
           window.location.href = loc;
          }
        }
        
      },
      showAside : function(){
        this.showFilters = true;
        $('#'+this.panelID).animate({'scrollTop':'0px','scrollLeft':'0px'},100).css({'overflow':'hidden'}).removeClass('scroll-vertically');
        $('ac-dropdown').each(function(){
          //if(!$(this).hasClass('tooltip-initialized')){
            window.angelCake.createTooltip( $(this),'click');
            //$(this).addClass('tooltip-initialized');
          //}
        });
        this.updatePickerCount();
      },
      prevPage : function(){
        this.myData.table_options.current_page_number--;
        this.submitFilters();
      },
      nextPage : function(){
        this.myData.table_options.current_page_number++;
        this.submitFilters();
      },
      changePage : function(){
        this.myData.table_options.current_page_number=(this.custom_page_number <= this.myData.table_options.total_page_count ? this.custom_page_number : this.myData.table_options.total_page_count);
        this.submitFilters();
      },
      hideAside : function(){

        this.showFilters = false;
        $('#'+this.panelID).css({'overflow':''}).addClass('scroll-vertically');
      },
      removeFilter : function(filter){
        filter.shown=false;
        this.updatePickerCount();
        filter.optionvalue='';
        filter.value='';
        filter.date='';
        filter.date_from='';
        filter.date_to='';
        return filter;
      },
      addFilter : function(filter){
        filter.shown=true;
        this.updatePickerCount();
        this.setOrder(filter.keyname);
        $('#'+this.panelID+'>aside').animate({ scrollTop: $('#'+this.panelID+'>aside').height()*2 }, 500);

        return filter;
      },
      setGridView : function(answer){
        
        if(answer){
          if(this.myData.table_options.has_grid_view){
            angelCake.setCookie('table_view','grid',999);
          }
          this.gridView = true;
          this.chartView = false;
          this.tableView = false;
          this.cardView = false;
          setTimeout(function(){ 
            $(window).trigger('resize');
          }, 100);
        }
        this.hideAside();
      },
      setTableView : function(answer){
        if(answer){
          if(this.myData.table_options.has_table_view){
            angelCake.setCookie('table_view','list',999);
          }
          this.gridView = false;
          this.chartView = false;
          this.tableView = true;
          this.cardView = false;
          setTimeout(function(){ 
            $(window).trigger('resize');
          }, 100);
        }
        this.hideAside();
      },
      setChartView : function(answer){
        if(answer){
          this.gridView = false;
          this.chartView = true;
          this.tableView = false;
          this.cardView = false;
          setTimeout(function(){ 
            $(window).trigger('resize');
          }, 100);
          
        }
        this.hideAside();
      },
      setCardView : function(answer){
        if(answer){
        	if(this.myData.table_options.has_card_view){
            angelCake.setCookie('table_view','card',999);
          }
          this.gridView = false;
          this.chartView = false;
          this.tableView = false;
          this.cardView = true;
          
          setTimeout(function(){ 
            $(window).trigger('resize');
          }, 100);
          
        }
        this.hideAside();
      },
      updatePickerCount : function(){
        var that = this;
        that.unSelectedFilterCount = 0;
        that.selectedFilterCount = 0;
        _.forEach(this.myData.filters, function(filter){
            if(!filter.shown && filter.type != 'hidden'){
              that.unSelectedFilterCount++;
            }else{
              that.selectedFilterCount++;
            }
        });
      
      },
      setOrder : function(keyname){
        var that = this;
        _.forEach(this.myData.filters, function(filter){
            if(filter.keyname == keyname){
              that.orderCounter++;
              filter.domOrder=that.orderCounter;
            }
        });
        //close all tooltips
        var instances = $.tooltipster.instances();
        $.each(instances, function(i, instance){

            instance.close();
        });

      },
      sortList : function(sort_key,sort_direction){
        if(sort_direction != 'none'){
          var that = this;
          _.forEach(this.myData.table_header, function(item){
              if(item.sort_key==sort_key){
                if(sort_direction=='asc'){
                  item.sort_direction = 'desc';
                  that.sort_direction = 'desc';
                }else{
                  item.sort_direction = 'asc';
                  that.sort_direction = 'asc';
                }
              }else{
                item.sort_direction='';
              }
          });

          if(that.sort_key!=sort_key){
            that.sort_direction = 'asc';
          }
          that.sort_key=sort_key;
          that.myData.table_options.current_page_number=1;
          that.submitFilters();
        }
      },
      fixStickyHeaders : function(){
        setTimeout(function() {
            $('.sticky-top+table>thead>tr').each(function(){
              var offset=$(this).parent().parent().prev().outerHeight();
                $(this).parent().css({'top':offset});
                $(this).find('>th').css({'top':offset});
            });
          }, 300);
      },
      parseData : function(data){
        var that = this;
        //that.myData = _.merge({}, that.myData_default, data);
        that.myData = data;
        that.view_button_count = 0;
        if(that.myData.table_options.has_grid_view){
          that.view_button_count++;
        }
        if(that.myData.table_options.has_chart_view){
          that.view_button_count++;
        }
        if(that.myData.table_options.has_table_view){
          that.view_button_count++;
        }
        if(that.myData.table_options.has_card_view){
          that.view_button_count++;
        }
        
        that.is_loading=false;
          
          that.ajaxLoadCount++;
          if(that.myData.table_options.chart_type=='horizontal-bar'){

            that.myData.table_options.chart_height = (function(){
              var multiplier = data.table_header.length - 1;
              var height = data.table_body.length * 50 * multiplier;
              return height+'px';
            })();
          }else{
            that.myData.table_options.chart_height = that.myData.table_options.chart_height+'px';
          }
          // if(typeof data.search_value == 'undefined'){
          //   data.search_value='';
          // }
          //if(data.search_value!=that.search_string && that.search_string !=''){

            that.search_string = that.myData.search_value;
          //}
          if(that.custom_page_number!=''){
            that.custom_page_number=that.myData.table_options.current_page_number;
          }
          $('#'+that.panelID).animate({'scrollTop':'0px','scrollLeft':'0px'},100);
          that.fixStickyHeaders();
          if(that.myData.filters.length<that.min_filter_count){
            _.forEach(that.myData.filters, function(filter){
              filter.shown=true;
            });
          }
          that.updatePickerCount();
          _.forEach(that.myData.filters, function(filter){
              if(filter.shown && filter.type!='hidden'){
                that.orderCounter++;
                filter.domOrder=that.orderCounter;
              }
          });
          
          _.forEach(that.myData.filters, function(filter){
            if(that.myData.filters.length>=that.min_filter_count){
              filter.init_optionvalue = filter.optionvalue;
              
              if(filter.type=='string'){
                if((filter.value!='' || filter.value!=null) && (filter.optionvalue!='' && filter.optionvalue!=null)){
                  filter.shown=true;
                }else{
                  filter.shown = false;
                }
                filter.init_value = filter.value;
              }
              if(filter.type=='select'){
                if(filter.optionvalue!='' && filter.optionvalue!=null){
                  filter.shown=true;
                }else{
                  filter.shown = false;
                }
              }
              if(filter.type=='date'){
                if((filter.value!='' || filter.value!=null) && (filter.optionvalue!='' && filter.optionvalue!=null)){
                  if(filter.optionvalue!='range'){
                    if(filter.date!='' && filter.date!=null){
                      filter.shown = true;
                    }else{
                      filter.shown= false;
                    }
                  }else{
                    if((filter.date_from!='' && filter.date_from!=null) && (filter.date_to!='' && filter.date_to!=null)){
                      filter.shown = true;
                    }else{
                      filter.shown= false;
                    }
                  }
                }else{
                  filter.shown = false;
                }
                filter.init_date = filter.date;
                filter.init_date_from = filter.date_from;
                filter.init_date_to = filter.date_to;
              } 
              filter.init_shown=filter.shown;
            }
            setTimeout(function(){ 
              $(window).trigger('resize');
            }, 100);
          });


          if(angelCake.getCookie('table_view')!=''){
            
            	if(angelCake.getCookie('table_view')=='card' && that.myData.table_options.has_card_view){
	              that.setCardView(true);
            	}else if(angelCake.getCookie('table_view')=='grid' && that.myData.table_options.has_grid_view){
            		that.setGridView(true);
            	}else{
            		that.setTableView(true);
            	}
            
          }else{
            if(that.ajaxLoadCount==1){
              if(that.myData.table_options.has_table_view){
                that.setTableView(true);
              }
              if(that.myData.table_options.has_grid_view){
                that.setGridView(true);
              }
              if(that.myData.table_options.has_chart_view){
                that.setChartView(true);                    
              }
              if(that.myData.table_options.has_grid_view){
                that.setGridView(true);                    
              }
            }
          }
          if(that.myData.table_options.has_card_view){
            that.setCardView(true);
        	}

          if(that.myData.table_options.has_chart_view){
          	that.setChartView(true);
            that.renderChart();
          }
          
      },
      getData : function(request){
        var that = this;

        $.ajax({
        url: ajaxSource,
        type: 'post',
        contentType: 'application/x-www-form-urlencoded',
        data: $.param( request, true ),
        success: function( data){
         that.parseData(data);
          
        },
        error: function( jqXhr, textStatus, errorThrown ){
          that.is_loading=false;
          that.myData.table_options.labels.empty_table='Ajax :: '+textStatus+' :: ';
          that.myData.table_options.labels.empty_table+=errorThrown;
           that.jqXhr = jqXhr;
           that.textStatus = textStatus;
           that.errorThrown = errorThrown;
        }
        });
      },

      validateFilters : function(){
        $('#form_'+this.panelID).on('submit',function(e){
          return false;
        });
        $('#submitbutton_'+this.panelID).click();
        $('div[data-required]>input.flatpickr-input').removeAttr('readonly').attr('required','required');
        if(document.getElementById('form_'+this.panelID).checkValidity()){
          this.myData.table_options.current_page_number=1;
          this.hideAside();
          this.submitFilters();
        }
      },
      clearFilters : function(){

        _.forEach(this.myData.filters, function(filter){
          if(filter.shown && filter.type!='hidden'){
            filter.optionvalue = '';
            if(filter.type=='string'){
              filter.value = '';
            }
            if(filter.type=='date'){
              filter.date = '';
              filter.date_from = '';
              filter.date_to = '';
            }
           
            filter.shown=false;
          }
        });
        this.updatePickerCount();
        this.submitFilters();
      },
      resetFilters : function(){
        if(this.myData.filters.length>=this.min_filter_count){
          _.forEach(this.myData.filters, function(filter){
            var changedCount = 0;
            var values ='';
            filter.shown = filter.init_shown;
         
            if(filter.shown && filter.type!='hidden'){
              
            
              filter.optionvalue=filter.init_optionvalue;
              if(filter.optionvalue!=null && filter.optionvalue!=''){
                values += filter.optionvalue;
              }
              if(filter.type=='string'){
                if(filter.init_value != filter.value && filter.init_optionvalue != filter.optionvalue){
                  changedCount++;
                }
                filter.value=filter.init_value;
                if(filter.value!=null && filter.value!=''){
                  values += filter.value;
                }
              }
              if(filter.type=='select'){
                if(filter.init_optionvalue != filter.optionvalue){
                  changedCount++;
                }
              }
              if(filter.type=='date'){
                if(filter.init_date != filter.date && filter.init_optionvalue != filter.optionvalue && filter.optionvalue!='range'){
                  changedCount++;
                }
                filter.date=filter.init_date;
                if(filter.date!=null && filter.date!=''){
                  values += filter.date;
                }
                if(filter.init_date_from != filter.date_from && filter.init_optionvalue != filter.optionvalue && filter.optionvalue=='range'){
                  changedCount++;
                }
                filter.date_from=filter.init_date_from;
                if(filter.date_from!=null && filter.date_from != ''){
                  values += filter.date_from;
                }
                if(filter.init_date_to != filter.date_to && filter.init_optionvalue != filter.optionvalue && filter.optionvalue=='range'){
                  changedCount++;
                }
                filter.date_to=filter.init_date_to;
                if(filter.date_from!=null && filter.date_from != ''){
                  values += filter.date_from;
                }
              }
              
              if(changedCount==0){ //if filters haven't changed but filter was removed, revert to initial shown state
                // if(filter.init_shown){
                   filter.shown = filter.init_shown;
                // }
              }
              if(values==''){ // if filter values have added up to an empty string, set shown state to false
                filter.shown = false;
              }

              
            }    
          });
        }
      },
      submitFilters : function(){
        
          var output = {};
          this.is_loading=true;
          var that = this;
          _.forEach(this.myData.filters, function(filter){
            if(filter.type=='string'){
              output[filter.keyname] = filter.value;
              output[filter.keyname+'_condition'] = filter.optionvalue;
            }
            if(filter.type=='date'){
              output[filter.keyname+'_date'] = filter.date;
              output[filter.keyname+'_date_from'] = filter.date_from;
              output[filter.keyname+'_date_to'] = filter.date_to;
              output[filter.keyname] = filter.optionvalue;
            }
            if(filter.type=='select'){
              output[filter.keyname] = filter.optionvalue;
            }
            if(filter.type=='hidden'){
              output[filter.keyname] = filter.value;
            }
          });
          output.page=that.myData.table_options.current_page_number;
          output['sort']= that.sort_key;
          output[that.myData.search_keyname] = that.search_string;
          output.direction=that.sort_direction;
          this.getData(output);
          this.hideAside();
        
      },
      renderChart : function(){
        var chartData = this.myData;
        this.myChart = angelCake.generateChart(this.myData.table_options.chart_type,this.panelID+'_chart',chartData);
      }
    },
    mounted : function(){
      this.myData_default = this.myData;
      if(inlineData!=''){
        this.parseData(inlineData);
      }else{
          this.getData({});
      }
      
      var that = this;
      that.panelWidth = $('#'+that.panelID).outerWidth();
      $(window).on('resize',function(){
        that.panelWidth = $('#'+that.panelID).outerWidth();
        that.fixStickyHeaders();
      });
    },

    watch : {
      custom_page_number : function (val){
        if(val>this.myData.table_options.total_page_count){
          this.custom_page_number = this.myData.table_options.total_page_count;
        }
      },
      search_string : function (val,oldval){
          if(val!=null){
            this.debouncedSearch(val);
          }
         
        
      },
      
      chartView : function(val){
        if(val){
          //this.renderChart();
        }
      }
    }
  });
};

head.ready('appJS',function(){
  $(document).ready(function(){
    
    var hasCharts = false;
    var loadPanels = function(){
      $('[data-json]').each(function(){
      	//if($(this).attr('data-type')=='card-view'){
        angelCake.generateCardTable('#'+$(this).attr('id'),$(this).attr('data-json'),$(this).data('myData'),$(this).attr('data-css'));
        //}
      });
    };
    $('[data-json]').each(function(){
      var myID = 'table'+(function(){ var d = new Date();return d.getTime();})();
      var myData = '';
      try { myData = JSON.parse($(this).html()); } catch(e) {  }
      $(this).attr('id',myID);
      $(this).data('myData',myData);
      if(myData!='' && myData.table_options.has_chart_view){ hasCharts=true; }
    });
    if(hasCharts){
      angelCake.loadJS('/angelCake/dist/js/extras/amcharts/amcharts.js',function(){
        angelCake.loadJS('/angelCake/dist/js/extras/amcharts/funnel.js',function(){
          angelCake.loadJS('/angelCake/dist/js/extras/amcharts/serial.js',function(){
            angelCake.loadJS('/angelCake/dist/js/extras/amcharts/pie.js',function(){
              angelCake.loadJS('/angelCake/dist/js/extras/amcharts/plugins/responsive/responsive.min.js',function(){
                loadPanels();
              });
            });
          });
        });
      });
    }else{
      loadPanels();
    }
    
    
    
    
  });
});
  